import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const getQrHistoryApi = async (payload = {}, authHeaders) => {
  try {
    const body = { apiVerb: 'GET', ...payload };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to fetch QR history' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const downloadQrCodesApi = async (payload = {}, authHeaders) => {
  try {
    const body = { 
      apiVerb: 'DOWNLOAD',
      runId: payload.runId,
      s3Link: payload.s3Link
    };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to download QR codes' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const downloadCsvApi = async (payload = {}, authHeaders) => {
  try {
    const body = { 
      apiVerb: 'DOWNLOAD_CSV',
      submissionId: payload.submissionId
    };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to download Excel file' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const getQrCountsApi = async (payload = {}, authHeaders) => {
  try {
    const body = { apiVerb: 'GET_COUNTS', ...payload };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to fetch QR counts' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const generateQrCodesApi = async (payload = {}, authHeaders) => {
  try {
    const body = { 
      apiVerb: 'GENERATE',
      skuId: payload.skuId,
      quantity: payload.quantity,
      qrCodeImageFormat: payload.qrCodeImageFormat,
      startSerialNo: payload.startSerialNo,
      createdById: payload.createdById,
      createdByName: payload.createdByName
    };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true, statusCode: 202 };
    }
    return { data: {}, status: false, errMsg: 'Failed to generate QR codes' };
  } catch (err) {
    // Check for specific HTTP status codes
    if (err.response?.status === 409) {
      return { 
        status: false, 
        statusCode: 409,
        errMsg: 'Duplicate serial/SKU found. Please check your data and try again.' 
      };
    }
    return { 
      status: false, 
      statusCode: err.response?.status || 500,
      errMsg: err.message || 'Failed to generate QR codes'
    };
  }
};

export const checkQrGenerationStatusApi = async (payload = {}, authHeaders) => {
  try {
    const body = { 
      apiVerb: 'STATUS',
      submissionId: payload.submissionId
    };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to check QR generation status' };
  } catch (err) {
    if (err.response?.status === 404) {
      return { 
        status: false, 
        statusCode: 404,
        errMsg: 'Submission not found' 
      };
    }
    return { 
      status: false, 
      statusCode: err.response?.status || 500,
      errMsg: err.message || 'Failed to check status'
    };
  }
};

export const softHideQrRunApi = async (payload = {}, authHeaders) => {
  try {
    const body = { 
      apiVerb: 'HIDE',
      runId: payload.runId,
      hiddenStatus: 'hidden',
      hiddenBy: payload.hiddenBy
    };
    const res = await apiCallPost(apiPaths.qrCode, body, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to hide QR run' };
  } catch (err) {
    if (err.response?.status === 404) {
      return { 
        status: false, 
        statusCode: 404,
        errMsg: 'QR generation run not found' 
      };
    }
    if (err.response?.status === 410) {
      return { 
        status: false, 
        statusCode: 410,
        errMsg: 'QR generation run is already hidden' 
      };
    }
    if (err.response?.status === 403) {
      return { 
        status: false, 
        statusCode: 403,
        errMsg: 'Unauthorized: Run does not belong to your company' 
      };
    }
    return { 
      status: false, 
      statusCode: err.response?.status || 500,
      errMsg: err.message || 'Failed to hide QR run'
    };
  }
};
